import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { IProperty } from 'src/interfaces/Property';
import { getAllProperties } from 'src/services/PropertiesService';

const REFRESH_TABLE_INTERVAL = 20000;

export const useGetAllProperties = (
	collectionIds: string[],
	showOnlyPropertiesInMyCollection: boolean,
	runGetPropertiesInterval: boolean
): UseQueryResult<IProperty[]> => {
	return useQuery({
		queryKey: ['properties', collectionIds, showOnlyPropertiesInMyCollection],
		queryFn: () => getAllProperties(collectionIds, showOnlyPropertiesInMyCollection),
		enabled: !!collectionIds,
		refetchInterval: runGetPropertiesInterval ? REFRESH_TABLE_INTERVAL : false
	});
};
